<div class="utf-syncing-information">

  <div class="header">
    <div class="spinner">
      <div></div>
    </div>
  
    <div class="row">
      <div class="col-12">
        <div class="sync-info-heading">
          <span id="info">{{cfetLabels.utf_syncing_info.syncing_info}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="divider">
    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>
  </div>

  <div class="row" id="cancel-divider">
    <div class="col-12">
      <a tabindex="0" href="https://www.att.com/" 
      type="link" id="cancel_link"><em aria-label=""></em>
      {{cfetButtonLabels.button_labels.cancel}}</a>
    </div>
  </div>
</div>